// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wG-z","tooltipWrapper":"xG-z","icon":"yG-z","tooltip":"zG-z","content":"AG-z"};